import { render, staticRenderFns } from "./GoodsModule.vue?vue&type=template&id=1a16da0e&scoped=true"
import script from "./GoodsModule.vue?vue&type=script&lang=js"
export * from "./GoodsModule.vue?vue&type=script&lang=js"
import style0 from "./GoodsModule.vue?vue&type=style&index=0&id=1a16da0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a16da0e",
  null
  
)

export default component.exports